module.exports = __webpack_public_path__ + "img/zizhumaidan.25c4361f.png";